import React from "react";

class Svg extends React.Component {
	constructor(props) {
		super(props);

		this.elClass = ['icon'];

		if (typeof props.extraClass !== 'undefined' && props.extraClass !== '') {
			this.elClass.push(props.extraClass);
		}
	}

	render() {
		return (
			<svg className={this.elClass.join(' ')} aria-hidden="true" focusable="false" onClick={() => this.props.onClick && this.props.onClick(false)}>
				<use xlinkHref={`#${this.props.icon}`} />
			</svg>
		);
	}
}

export default Svg;
